import { useEffect, useState } from "react";

import type { IOnOffSwitchConfig } from "app/components/React/WidgetContainer/types";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

interface UseCoreCompetitorsToggleOptions {
    hasCompetitiveSet: boolean;
}

export const useCoreCompetitorsToggle = ({ hasCompetitiveSet }: UseCoreCompetitorsToggleOptions) => {
    const [isCoreCompetitorsOn, setIsCoreCompetitorsOn] = useState<boolean>(hasCompetitiveSet);

    useEffect(() => {
        setIsCoreCompetitorsOn(hasCompetitiveSet);
    }, [hasCompetitiveSet]);

    const handleToggle = () => {
        setIsCoreCompetitorsOn((prev) => {
            const next = !prev;
            allTrackers.dispatchTrackEvent("Switch", "switch", `Core Competitors/${next ? "On" : "Off"}`);
            return next;
        });
    };

    const onOffSwitchConfig: IOnOffSwitchConfig[] = [
        {
            isSelected: isCoreCompetitorsOn && hasCompetitiveSet,
            isDisabled: !hasCompetitiveSet,
            onClick: handleToggle,
            onLabel: translate("llm.brands-visibility.core_competitors.label"),
            tooltip: !hasCompetitiveSet
                ? { content: translate("llm.brands-visibility.core_competitors.disabled.tooltip") }
                : undefined,
        },
    ];

    return {
        isCoreCompetitorsOn: isCoreCompetitorsOn && hasCompetitiveSet,
        onOffSwitchConfig,
    };
};
